import React from 'react';
import { Navigate } from 'react-router-dom';
import { useIndexRedirectTarget } from '../../hooks/useIndexRedirectTarget';

export const HeadcountIndexRedirect = (): JSX.Element => {
  const target = useIndexRedirectTarget();
  return <Navigate to={target} replace />;
};
